<template>
  <div>
    <div class="card-header">
      <div class="card-header-title">
        {{ titulo }}
      </div>

      <div class="card-header-text" v-if="hasShowTable">
        <div>
          <strong> {{ texto1 }} </strong>
        </div>
        <div class="card-header-text-2">
          <span>{{ texto2 }}</span>
        </div>
      </div>

      <div
        class="card-header-text-no-content"
        v-if="!hasShowTable && !hasShowError && !isLoading"
      >
        <div>
          <strong> Seu plano não possui coparticipação </strong>
        </div>
        <div class="card-header-text-2-no-content">
          <span
            >Seu plano cobre integralmente os procedimentos, por isso não há uma
            tabela de coparticipação para exibir.</span
          >
        </div>
      </div>

      <div class="card-header-text-error" v-if="hasShowError">
        <div class="info-circle">
          <img class="info-error" src="../../assets/images/info.svg" />
        </div>
        <div>
          <strong>Não foi possível carregar as informações</strong>
        </div>
        <div class="card-header-text-2-error">
          <span
            >Por favor, atualize a página ou tente novamente mais tarde.</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titulo: String,
    texto1: String,
    texto2: String,
    texto3: String,
    hasShowTable: Boolean,
    hasShowError: Boolean,
    isLoading: Boolean,
  },
};
</script>

<style scoped>
.info-error {
  width: 50px;
}
.info-letter {
  color: white;
  font-family: serif;
  font-weight: bold;
  font-size: 30px;
  line-height: 0;
  margin-top: -2px;
}
.card-header-text-no-content,
.card-header-text-error {
  margin-top: 40px;
}
.card-header-text-error {
  margin-top: 20px;
}
.card-header-text-no-content strong,
.card-header-text-error strong {
  font-family: UnimedSlab-SemiBold;
  font-size: 26px;
}

.card-header-text-no-content strong {
  color: #00945e;
}
.card-header-text-2-no-content {
  font-weight: bold;
  font-size: 14px;
}

.card-header {
  width: 100%;
  /* height: 225px; */
  display: block;
  text-align: center;
  background-color: #f3f3f3;
}

.card-header-title {
  color: #00945e;
  font-size: 35px;
  font-family: UnimedSlab-SemiBold;
  width: auto;
  margin: auto;
  padding-top: 40px;
  padding-bottom: 15px;
  border-bottom: 1px solid #dcdfe2;
}

.card-header-text {
  font-size: 14px;
  font-family: UnimedSans-SemiBold;
  padding-top: 15px;
}

.card-header-text-2 {
  font-family: UnimedSans-Regular;
}

@media (min-width: 320px) {
  .card-header {
    height: 280px;
  }
}
@media (min-width: 480px) {
  .card-header {
    height: 225px;
  }
}
</style>
